import React from 'react'

import {TagsList as TagsListShared, TagsListProps} from '../../../../components-shared/TagsList'

import {classes, st} from './TagsList.st.css'

export const TagsList: React.FC<TagsListProps> = (props) => {
  return (
    <TagsListShared
      {...props}
      boxSelectionClassName={st(classes.boxSelection)}
      timeClassName={st(classes.time)}
      nonWorkingHoursTimeSlotClassName={st(classes.nonWorkingHoursTimeSlot)}
    />
  )
}
